/* PDP mobile image counter — "‹ 3/5 ›" under the swipe gallery (≤767px),
   kept in sync with the gallery's Swiper both ways. */
(function () {
  var MQ = window.matchMedia('(max-width: 767px)');

  var css = document.createElement('style');
  css.textContent =
    '.pdp-counter{display:none}' +
    '@media (max-width:767px){' +
      '.pdp-counter{display:flex;align-items:center;justify-content:center;gap:18px;padding:12px 0 4px;font-size:13px;letter-spacing:.06em;color:#0c0c50;font-variant-numeric:tabular-nums}' +
      '.pdp-counter[hidden]{display:none}' +
      '.pdp-counter__btn{display:flex;align-items:center;justify-content:center;width:28px;height:28px;padding:0;margin:0;border:0;background:none;color:inherit;font-size:20px;line-height:1}' +
      '.pdp-counter__btn:disabled{opacity:.3}' +
      '.pdp-counter__num{min-width:36px;text-align:center}' +
    '}';
  document.head.appendChild(css);

  function initGallery(gallery) {
    if (gallery.dataset.counterInit) return;
    var viewport = gallery.querySelector('.swiper-container');
    if (!viewport || !viewport.swiper) return;
    gallery.dataset.counterInit = '1';

    var swiper = viewport.swiper;
    var bar = document.createElement('div');
    bar.className = 'pdp-counter';
    bar.innerHTML =
      '<button type="button" class="pdp-counter__btn" data-dir="prev" aria-label="Previous image">&#8249;</button>' +
      '<span class="pdp-counter__num" aria-live="polite"></span>' +
      '<button type="button" class="pdp-counter__btn" data-dir="next" aria-label="Next image">&#8250;</button>';
    gallery.insertAdjacentElement('afterend', bar);

    var num = bar.querySelector('.pdp-counter__num');
    var prev = bar.querySelector('[data-dir="prev"]');
    var next = bar.querySelector('[data-dir="next"]');
    var visible = [];

    function slides() { return Array.prototype.slice.call(swiper.slides); }

    function build() {
      var s = viewport.swiper;
      if (!s || !MQ.matches) { bar.hidden = true; return; }
      swiper = s;
      var all = slides();
      visible = all.filter(function (sl) { return getComputedStyle(sl).display !== 'none'; })
                   .map(function (sl) { return all.indexOf(sl); });
      bar.hidden = visible.length < 2;
      sync();
    }

    function sync() {
      var pos = visible.indexOf(swiper.activeIndex);
      if (pos < 0) pos = 0;
      num.textContent = (pos + 1) + '/' + visible.length;
      prev.disabled = pos === 0;
      next.disabled = pos === visible.length - 1;
    }

    function go(step) {
      var pos = visible.indexOf(swiper.activeIndex);
      var target = visible[Math.min(Math.max(pos + step, 0), visible.length - 1)];
      if (target != null) swiper.slideTo(target);
    }

    prev.addEventListener('click', function () { go(-1); });
    next.addEventListener('click', function () { go(1); });
    swiper.on('slideChange', sync);
    swiper.on('transitionEnd', sync);

    // Variant image grouping swaps slides — recount when the wrapper changes.
    var wrapper = viewport.querySelector('.swiper-wrapper');
    var t;
    if (wrapper) {
      new MutationObserver(function (muts) {
        var relevant = muts.some(function (m) { return m.type === 'childList' || m.attributeName === 'style' && m.target.classList.contains('swiper-slide'); });
        if (!relevant) return;
        clearTimeout(t);
        t = setTimeout(build, 120);
      }).observe(wrapper, { childList: true, subtree: true, attributes: true, attributeFilter: ['style'] });
    }
    MQ.addEventListener ? MQ.addEventListener('change', build) : MQ.addListener(build);
    build();
  }

  function scan() {
    document.querySelectorAll('.product-area__media .theme-gallery').forEach(initGallery);
  }

  var tries = 0;
  (function wait() {
    scan();
    var pending = Array.prototype.some.call(
      document.querySelectorAll('.product-area__media .theme-gallery'),
      function (g) { return !g.dataset.counterInit; }
    );
    if (pending && tries++ < 40) setTimeout(wait, 250);
  })();

  document.addEventListener('shopify:section:load', function () { tries = 0; setTimeout(scan, 300); });
})();
